import { useEffect, useMemo, useState } from "react";
import useMenuItems from "./useMenuItems";
import { AiOutlineLoading3Quarters, AiOutlineMenu } from "react-icons/ai";
import { Sidebar } from "primereact/sidebar";
import { NavLink, useLocation } from "react-router-dom";
import { BiArrowBack, BiPowerOff, BiUser } from "react-icons/bi";
import useLogout from "api/UserResource/useLogout";
import { RiArrowDownSFill } from "react-icons/ri";

const isPathActive = (pathname, path) => pathname === path || pathname.startsWith(`${path}/`);

const MobileMenu = () => {
	const [visibleLeft, setVisibleLeft] = useState(false);
	const location = useLocation();
	const menuItems = useMenuItems();
	const activeGroupIds = useMemo(
		() =>
			menuItems
				.filter((item) => item.type === "group")
				.filter((group) => group.children.some((child) => isPathActive(location.pathname, child.to)))
				.map((group) => group.id),
		[location.pathname, menuItems],
	);
	const [expandedGroupIds, setExpandedGroupIds] = useState([]);

	useEffect(() => {
		setExpandedGroupIds((current) => {
			const availableGroupIds = menuItems
				.filter((item) => item.type === "group")
				.map((item) => item.id);
			const sanitizedCurrent = current.filter((id) => availableGroupIds.includes(id));

			if (sanitizedCurrent.length > 0) {
				return sanitizedCurrent;
			}

			return activeGroupIds;
		});
	}, [activeGroupIds, menuItems]);

	const toggleGroup = (groupId) => {
		setExpandedGroupIds((current) =>
			current.includes(groupId)
				? current.filter((id) => id !== groupId)
				: [...current, groupId],
		);
	};

	const { mutateAsync, isLoading } = useLogout();
	const handleLogout = async () => {
		await mutateAsync();
	};
	return (
		<>
			<button type="button" onClick={() => setVisibleLeft(true)}>
				<AiOutlineMenu size={30} />
			</button>
			<Sidebar visible={visibleLeft} position="left" onHide={() => setVisibleLeft(false)}>
				<div className="flex flex-col">
					<div className="space-y-4">
						{menuItems.map((item) => {
							if (item.type === "link") {
								return (
									<NavLink
										key={item.to}
										to={item.to}
										className="text-akgreenest flex items-center gap-2 text-base"
										activeClassName="text-akgreener font-cera-black"
									>
										{item.icon}
										{item.label}
									</NavLink>
								);
							}

							const isExpanded = expandedGroupIds.includes(item.id);
							const isGroupActive = item.children.some((child) =>
								isPathActive(location.pathname, child.to),
							);

							return (
								<div key={item.id} className="space-y-2">
									<button
										type="button"
										onClick={() => toggleGroup(item.id)}
										className={`w-full flex items-center justify-between text-base ${
											isGroupActive ? "text-akgreener font-cera-black" : "text-akgreenest"
										}`}
									>
										<span className="flex items-center gap-2">
											{item.icon}
											{item.label}
										</span>
										<RiArrowDownSFill
											size={18}
											className={`transition-transform ${isExpanded ? "rotate-180" : ""}`}
										/>
									</button>

									{isExpanded && (
										<div className="ml-5 space-y-2 border-l border-akgreenest/20 pl-3">
											{item.children.map((child) => (
												<NavLink
													key={child.to}
													to={child.to}
													className="text-akgreenest flex items-center gap-2 text-base"
													activeClassName="text-akgreener font-cera-black"
												>
													{child.icon}
													{child.label}
												</NavLink>
											))}
										</div>
									)}
								</div>
							);
						})}
					</div>

					<div className="flex-1 flex flex-col gap-2 justify-end py-6 mt-6 border-t border-gray-300 ">
						<NavLink to={"/books"} className="flex gap-1 items-center">
							<BiArrowBack size={20} /> Home
						</NavLink>
						<NavLink to="/my-account" className="flex gap-1 items-center">
							<BiUser size={20} />
							My Profile
						</NavLink>

						<button
							type="button"
							className="px-2 py-2 rounded-full bg-akgreener shadow-md flex gap-1 items-center text-white max-w-max"
							onClick={() => handleLogout()}
						>
							{isLoading ? (
								<AiOutlineLoading3Quarters size={20} className="animate-spin text-white" />
							) : (
								<BiPowerOff size={20} className={`text-white`} />
							)}
							Logout
						</button>
					</div>
				</div>
			</Sidebar>
		</>
	);
};

export default MobileMenu;
